import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from "../components/Sidebar";

const MyPoliciesPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedPolicies, setSelectedPolicies] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const navigate = useNavigate();
  const [policies, setPolicies] = useState([]);
  
  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user?.id) return;
        const res = await fetch(`${import.meta.env.VITE_API_URL}/v1/customer/customer-fetch-policy/${user.id}`);
        const data = await res.json();
        if (res.ok) setPolicies(data.policyData);
      } catch (err) {
        console.error("🚫 Failed to fetch policies:", err);
      }
    };
    fetchPolicies();
  }, []);

  const [filters, setFilters] = useState({ productName: '', status: '', policyType: '' });
  const handleFilterChange = (key, value) => setFilters(prev => ({ ...prev, [key]: value }));
  const clearFilters = () => setFilters({ productName: '', status: '', policyType: '' });

  const handlePolicySelect = (policyId) => {
    setSelectedPolicies(prev => prev.includes(policyId) ? prev.filter(id => id !== policyId) : [...prev, policyId]);
  };


  const companyList = [...new Set(policies.map(p => p.productName).filter(Boolean))];
  const statusList = [...new Set(policies.map(p => p.status).filter(Boolean))];
  const insuranceTypeList = [...new Set(policies.map(p => p.policyType).filter(Boolean))];

  const filteredPolicies = policies.filter(p =>
    (!filters.productName || p.productName === filters.productName) &&
    (!filters.status || p.status === filters.status) &&
    (!filters.policyType || p.policyType === filters.policyType)
  );

  const getStatusClass = (status) => {
    if (!status) return 'default';
    const s = status.toLowerCase();
    if (s.includes('active')) return 'active';
    if (s.includes('due')) return 'due';
    if (s.includes('expired') || s.includes('lapsed')) return 'expired';
    return 'default';
  };

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="main-content">
        <div className="my-policies-clean">
          
          {/* Header */}
          <div className="policies-header">
            <h1 className="page-title">My Policies</h1>
            <button className="add-policy-btn" onClick={() => navigate('/customer/add-insurance')}>
              <i className="bi bi-plus"></i> Add Policy
            </button>
          </div>

         {/* Filters */}
          <div className="filters-box">
            <div className="filter-group">
              <select 
                className="filter-select"
                value={filters.productName} 
                onChange={(e) => handleFilterChange('productName', e.target.value)}
              >
                <option value="">All Companies</option>
                {companyList.map((name, i) => (
                  <option key={i} value={name}>{name}</option>
                ))}
              </select>

              <select 
                className="filter-select"
                value={filters.status} 
                onChange={(e) => handleFilterChange('status', e.target.value)}
              >
                <option value="">All Status</option>
                {statusList.map((s, i) => (
                  <option key={i} value={s}>{s}</option>
                ))}
              </select>

              <select 
                className="filter-select"
                value={filters.policyType} 
                onChange={(e) => handleFilterChange('policyType', e.target.value)}
              >
                <option value="">All Types</option>
                {insuranceTypeList.map((t, i) => (
                  <option key={i} value={t}>{t}</option>
                ))}
              </select>
            </div>

            <button className="clear-filters-btn" onClick={clearFilters}>
              Clear All
            </button>
          </div>

         {/* Policies */}
      {/* Policies */}
<div className="row">
  {filteredPolicies.length === 0 ? (
    <p className="no-policies">No policies found matching your filters.</p>
  ) : (
    filteredPolicies.map((policy, i) => {
      // Limit productName to 2 words
      const shortName = policy.productName
        ? policy.productName.split(" ").slice(0, 2).join(" ")
        : "Unknown Company";

      return (
        <div className="col-md-4 mb-4" key={policy._id || i}>
          <div className="policy-card-clean">
            
            {/* Card Header */}
            <div className="card-header">
              <div className="status-badge-clean">
                <span className={`status-indicator ${getStatusClass(policy.status)}`}>
                  <i className={`bi ${
                    policy.status === 'Due' ? 'bi-clock-fill' : 
                    policy.status === 'Overdue' ? 'bi-exclamation-triangle-fill' : 'bi-check-circle-fill'
                  }`}></i>
                  {policy.status || 'DUE'}
                </span>
              </div>
              <div className="policy-number">
                {policy.policyNumber || 'POLRIS123'}
              </div>
            </div>

            {/* Policy Info */}
            <div className="policy-info">
              <div className="policy-type">
                {(policy.policyType || 'MOTOR INSURANCE').toUpperCase()}
              </div>
              <div className="policy-name">
                {shortName}
              </div>
            </div>

            {/* Policy Details Grid */}
            <div className="policy-details-grid">
              <div className="detail-item">
                <span className="detail-label">Premium Due:</span>
                <span className="detail-value highlight">
                  ₹{policy.premiumAmount || 'NA'}
                </span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Due Date:</span>
                <span className="detail-value">
                  {policy.endDate || 'NA'}
                </span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Policy Term:</span>
                <span className="detail-value">
                  {policy.tenure || 'NA'}
                </span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Coverage:</span>
                <span className="detail-value"> 
                  ₹{policy.sumInsured || ' 00'}
                </span>
              </div>
            </div>

            {/* Card Actions */}
            <div className="card-actions-clean">
              <button 
                className="action-btn-clean view-btn-clean"
                onClick={() => navigate(`/customer/policy-view/${policy.customerId}/${policy._id}/${policy.policyNumber}`)}
              >
                <i className="bi bi-eye"></i>
                View
              </button>
              <button 
                className="action-btn-clean pay-btn-clean"
                onClick={() => console.log("Pay Now for:", policy._id)}
              >
                <i className="bi bi-credit-card"></i>
                Pay Now
              </button>
            </div>
          </div>
        </div>
      );
    })
  )}
</div>
        </div>
      </div>
    </div>
  );
};

export default MyPoliciesPage;
